import { v4 as uuid } from "uuid";
import { z } from "zod";
export const projectLevelLabourHourCommitmentType = [];
export var SocialCommitmentTypeHour;
(function (SocialCommitmentTypeHour) {
    SocialCommitmentTypeHour["DefaultHour"] = "social-commitment-type_default-hours";
    SocialCommitmentTypeHour["LocalJobsFirst"] = "social-commitment-type_local-jobs-first";
    SocialCommitmentTypeHour["MPSGHoursRequirement"] = "social-commitment-mpsg-hours-requirement";
    SocialCommitmentTypeHour["VictorianPriorityWorkforce"] = "social-commitment-type_victorian-priority-workforce";
    SocialCommitmentTypeHour["FemaleParticipation"] = "social-commitment-type_female-participation";
    SocialCommitmentTypeHour["BepTradeHours"] = "social-commitment-type_bep-trade";
    SocialCommitmentTypeHour["BepNonTradeHours"] = "social-commitment-type_bep-non-trade";
    SocialCommitmentTypeHour["BepManagementHours"] = "social-commitment-type_bep-management";
    SocialCommitmentTypeHour["FemaleApprenticeAndTrainee"] = "social-commitment-type_female-apprentices-and-trainees";
    SocialCommitmentTypeHour["AboriginalTorresStraitIslanderParticipation"] = "social-commitment-type_aboriginal-torres-strait-island-participation";
    SocialCommitmentTypeHour["GeespApprentice"] = "social-commitment-type_geesp-apprentice";
    // South Australia
    SocialCommitmentTypeHour["AboriginalEmployment"] = "social-commitment-type_aboriginal-employment";
    SocialCommitmentTypeHour["SAWP"] = "social-commitment-type_sa-workforce-participation";
    SocialCommitmentTypeHour["LongTermUnemployed"] = "social-commitment-type_long-term-unemployed";
    SocialCommitmentTypeHour["WomenInConstruction"] = "social-commitment-type_women-in-construction";
    SocialCommitmentTypeHour["TAGroup"] = "social-commitment-type_ta-group";
    SocialCommitmentTypeHour["NominatedGroup"] = "social-commitment-type_nominated-group";
    // Queensland
    SocialCommitmentTypeHour["LocalWorkforce"] = "social-commitment-type_local-workforce";
    SocialCommitmentTypeHour["IndigenousParticipation"] = "social-commitment-type_indigenous-participation";
    SocialCommitmentTypeHour["CulturallyAndLinguisticallyDiverse"] = "social-commitment-type_culturally-and-linguistically-diverse";
    SocialCommitmentTypeHour["ProjectTrainingOpportunities"] = "social-commitment-type_project-training-opportunities";
    SocialCommitmentTypeHour["TargettedInclusiveATC"] = "social-commitment-type_targeted-inclusive-atc";
    SocialCommitmentTypeHour["NewTrainingOpportunities"] = "social-commitment-type_new-training-opportunities";
    // ACT
    SocialCommitmentTypeHour["ACTIndigenousParticipation"] = "social-commitment-type_act-indigenous-participation";
    SocialCommitmentTypeHour["ACTLearningWorkforce"] = "social-commitment-type_act-learning-workforce";
    SocialCommitmentTypeHour["ACTTradeApprentices"] = "social-commitment-type_act-trade-apprentices";
    SocialCommitmentTypeHour["ACTYouthWorkforce"] = "social-commitment-type_act-youth-workforce";
    SocialCommitmentTypeHour["ACTFemaleNonTraditional"] = "social-commitment-type_act-female-non-traditional";
    SocialCommitmentTypeHour["ACTGraduateCadetRotations"] = "social-commitment-type_act-graduate-cadet-rotations";
    SocialCommitmentTypeHour["ACTCanberraRegionFTE"] = "social-commitment-type_act-canberra-region-fte";
    SocialCommitmentTypeHour["ACTCanberraInternalLabour"] = "social-commitment-type_act-canberra-internal-labour";
    SocialCommitmentTypeHour["ACTCanberraSubcontractorLabour"] = "social-commitment-type_act-canberra-subcontractor-labour";
})(SocialCommitmentTypeHour || (SocialCommitmentTypeHour = {}));
export const labourHourCommitmentTypeToString = (targetName) => {
    switch (targetName) {
        default:
        case SocialCommitmentTypeHour.DefaultHour:
            return "Custom Hour";
        case SocialCommitmentTypeHour.LocalJobsFirst:
            return "Local Jobs First";
        case SocialCommitmentTypeHour.MPSGHoursRequirement:
            return "MPSG Hours Requirement";
        case SocialCommitmentTypeHour.VictorianPriorityWorkforce:
            return "Victorian Priority Workforce";
        case SocialCommitmentTypeHour.FemaleParticipation:
            return "Female Participation";
        case SocialCommitmentTypeHour.BepTradeHours:
            return "BEP hours (trade roles)";
        case SocialCommitmentTypeHour.BepNonTradeHours:
            return "BEP hours (non-trade roles)";
        case SocialCommitmentTypeHour.BepManagementHours:
            return "BEP hours (management or supervisory roles)";
        case SocialCommitmentTypeHour.FemaleApprenticeAndTrainee:
            return "Female Apprentices and Trainees";
        case SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation:
            return "Indigenous Participation";
        case SocialCommitmentTypeHour.GeespApprentice:
            return "GEESP Apprentice Program";
        // South Australia
        case SocialCommitmentTypeHour.AboriginalEmployment:
            return "Aboriginal Employment";
        case SocialCommitmentTypeHour.SAWP:
            return "SA Workforce Participation";
        case SocialCommitmentTypeHour.LongTermUnemployed:
            return "Long Term Unemployed";
        case SocialCommitmentTypeHour.WomenInConstruction:
            return "Women in Construction";
        case SocialCommitmentTypeHour.TAGroup:
            return "Trainees and Apprentices Group";
        case SocialCommitmentTypeHour.NominatedGroup:
            return "Nominated Group";
        // Queensland
        case SocialCommitmentTypeHour.LocalWorkforce:
            return "Local Workforce";
        case SocialCommitmentTypeHour.IndigenousParticipation:
            return "Indigenous Participation";
        case SocialCommitmentTypeHour.CulturallyAndLinguisticallyDiverse:
            return "Culturally & Linguistically Diverse";
        case SocialCommitmentTypeHour.ProjectTrainingOpportunities:
            return "Project Training Opportunities";
        case SocialCommitmentTypeHour.TargettedInclusiveATC:
            return "Targeted Inclusive Apprentice & Trainee Employment";
        case SocialCommitmentTypeHour.NewTrainingOpportunities:
            return "New Training Opportunities";
        // ACT
        case SocialCommitmentTypeHour.ACTIndigenousParticipation:
            return "Aboriginal & Torres Strait Islander Workforce Participation";
        case SocialCommitmentTypeHour.ACTLearningWorkforce:
            return "New Entrants/Trainees | Learning Workforce";
        case SocialCommitmentTypeHour.ACTTradeApprentices:
            return "Trade Qualified Apprentices";
        case SocialCommitmentTypeHour.ACTYouthWorkforce:
            return "Workforce under 25yo";
        case SocialCommitmentTypeHour.ACTFemaleNonTraditional:
            return "Female Participation | Non Traditional Roles";
        case SocialCommitmentTypeHour.ACTGraduateCadetRotations:
            return "Graduate & Cadet Rotations";
        case SocialCommitmentTypeHour.ACTCanberraRegionFTE:
            return "Canberra Region | FTE";
        case SocialCommitmentTypeHour.ACTCanberraInternalLabour:
            return "Canberra Region | Project Team Internal Labour Hours";
        case SocialCommitmentTypeHour.ACTCanberraSubcontractorLabour:
            return "Canberra Region | Subcontractor Labour Hours";
    }
};
export const labourHourCommitmentTypeToAbbreviatedString = (targetName) => {
    switch (targetName) {
        case SocialCommitmentTypeHour.DefaultHour:
            return "Custom";
        case SocialCommitmentTypeHour.LocalJobsFirst:
            return "LJF";
        case SocialCommitmentTypeHour.MPSGHoursRequirement:
            return "MPSG";
        case SocialCommitmentTypeHour.VictorianPriorityWorkforce:
            return "VPW";
        case SocialCommitmentTypeHour.FemaleParticipation:
            return "FP";
        case SocialCommitmentTypeHour.BepTradeHours:
            return "BEPT";
        case SocialCommitmentTypeHour.BepNonTradeHours:
            return "BEPNT";
        case SocialCommitmentTypeHour.BepManagementHours:
            return "BEPM";
        case SocialCommitmentTypeHour.FemaleApprenticeAndTrainee:
            return "FT";
        case SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation:
            return "IP";
        case SocialCommitmentTypeHour.GeespApprentice:
            return "GEESP";
        // South Australia
        case SocialCommitmentTypeHour.AboriginalEmployment:
            return "AE";
        case SocialCommitmentTypeHour.SAWP:
            return "SAWP";
        case SocialCommitmentTypeHour.LongTermUnemployed:
            return "LTU";
        case SocialCommitmentTypeHour.WomenInConstruction:
            return "WIC";
        case SocialCommitmentTypeHour.TAGroup:
            return "TAG";
        case SocialCommitmentTypeHour.NominatedGroup:
            return "NG";
        // Queensland
        case SocialCommitmentTypeHour.LocalWorkforce:
            return "LW";
        case SocialCommitmentTypeHour.IndigenousParticipation:
            return "IP";
        case SocialCommitmentTypeHour.CulturallyAndLinguisticallyDiverse:
            return "CALD";
        case SocialCommitmentTypeHour.ProjectTrainingOpportunities:
            return "PTO";
        case SocialCommitmentTypeHour.TargettedInclusiveATC:
            return "TIATC";
        case SocialCommitmentTypeHour.NewTrainingOpportunities:
            return "NTO";
        // ACT
        case SocialCommitmentTypeHour.ACTIndigenousParticipation:
            return "ATSI";
        case SocialCommitmentTypeHour.ACTLearningWorkforce:
            return "LWF";
        case SocialCommitmentTypeHour.ACTTradeApprentices:
            return "TQA";
        case SocialCommitmentTypeHour.ACTYouthWorkforce:
            return "YWF";
        case SocialCommitmentTypeHour.ACTFemaleNonTraditional:
            return "FNT";
        case SocialCommitmentTypeHour.ACTGraduateCadetRotations:
            return "GCR";
        case SocialCommitmentTypeHour.ACTCanberraRegionFTE:
            return "CRFTE";
        case SocialCommitmentTypeHour.ACTCanberraInternalLabour:
            return "CRIL";
        case SocialCommitmentTypeHour.ACTCanberraSubcontractorLabour:
            return "CRSL";
    }
};
export const labourHourCommitmentTypeToDescription = (socialCommitmentType) => {
    switch (socialCommitmentType) {
        default:
        case SocialCommitmentTypeHour.DefaultHour:
            return "Custom Hours: Description missing - please contact support";
        case SocialCommitmentTypeHour.LocalJobsFirst:
            return "Workers on a project residing within 50km of the Project address.";
        case SocialCommitmentTypeHour.MPSGHoursRequirement:
            return "Contribution of local apprentices, trainees and cadets to overall labour hours on a project.";
        case SocialCommitmentTypeHour.VictorianPriorityWorkforce:
            return "Contribution in labour hours to a Project by cohorts of disadvantaged Victorians under the Social Procurement Framework (SPF)";
        case SocialCommitmentTypeHour.FemaleParticipation:
            return "Contribution in labour hours to a Project by females in trade, non-trade, and on-site managerial/supervisory and specialist roles under the Building Equality Policy (BEP) implemented by the Social Procurement Framework (SPF).";
        case SocialCommitmentTypeHour.BepTradeHours:
            return "Contribution in labour hours to a Project by females in trade roles under the Building Equality Policy (BEP) implemented by the Social Procurement Framework (SPF)";
        case SocialCommitmentTypeHour.BepNonTradeHours:
            return "Contribution in labour hours to a Project by females in non-trade roles under the Building Equality Policy (BEP) implemented by the Social Procurement Framework (SPF)";
        case SocialCommitmentTypeHour.BepManagementHours:
            return "Contribution in labour hours to a Project by females in on-site managerial/supervisory and specialist roles under the Building Equality Policy (BEP) implemented by the Social Procurement Framework (SPF)";
        case SocialCommitmentTypeHour.FemaleApprenticeAndTrainee:
            return "Contribution in labour hours to a Project by female apprentices and trainees";
        case SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation:
            return "Contribution in labour hours to a Project by people that are of Aboriginal or Torres Strait Islander descent, or who identify as an Aboriginal or Torres Strait Islander person and are accepted as such by the community in which they live or formerly lived.";
        // South Australia
        case SocialCommitmentTypeHour.AboriginalEmployment:
            return "Aboriginal Employment target for South Australia projects.";
        case SocialCommitmentTypeHour.SAWP:
            return "SA Workforce Participation (SAWP) - workers within 125km of project address in South Australia.";
        case SocialCommitmentTypeHour.LongTermUnemployed:
            return "Nominated Groups - Long term unemployed and people with barriers to employment (12+ months).";
        case SocialCommitmentTypeHour.WomenInConstruction:
            return "Women in Construction participation target for South Australia projects.";
        case SocialCommitmentTypeHour.TAGroup:
            return "Trainees and Apprentices Group (TA Group) target for South Australia projects.";
        case SocialCommitmentTypeHour.NominatedGroup:
            return "Nominated Groups - Graduates, Cadets, Long term unemployed, People with barriers to employment, and Upskilling.";
        // Queensland
        case SocialCommitmentTypeHour.LocalWorkforce:
            return "Local Workforce (region specific) - workers within 125km of project address.";
        case SocialCommitmentTypeHour.IndigenousParticipation:
            return "Indigenous Participation target for Queensland projects.";
        case SocialCommitmentTypeHour.CulturallyAndLinguisticallyDiverse:
            return "Culturally & Linguistically Diverse (CALD) Workforce participation target.";
        case SocialCommitmentTypeHour.ProjectTrainingOpportunities:
            return "Project Training Opportunities target for Queensland projects.";
        case SocialCommitmentTypeHour.TargettedInclusiveATC:
            return "Targeted Inclusive Apprentice & Trainee Employment for Queensland projects.";
        case SocialCommitmentTypeHour.NewTrainingOpportunities:
            return "New training opportunities target for Queensland projects.";
        // ACT
        case SocialCommitmentTypeHour.ACTIndigenousParticipation:
            return "Aboriginal & Torres Strait Islander Workforce Participation for ACT projects.";
        case SocialCommitmentTypeHour.ACTLearningWorkforce:
            return "New Entrants/Trainees | Learning Workforce - Trainees and Interns contribution for ACT projects.";
        case SocialCommitmentTypeHour.ACTTradeApprentices:
            return "Trade Qualified Apprentices participation target for ACT projects.";
        case SocialCommitmentTypeHour.ACTYouthWorkforce:
            return "Workforce under 25yo - workers under 25 years of age participation target for ACT projects.";
        case SocialCommitmentTypeHour.ACTFemaleNonTraditional:
            return "Female Participation | Non Traditional Roles - female workers in trade roles for ACT projects.";
        case SocialCommitmentTypeHour.ACTGraduateCadetRotations:
            return "Graduate & Cadet Rotations - Graduates, Cadets and Upskilling workers for ACT projects.";
        case SocialCommitmentTypeHour.ACTCanberraRegionFTE:
            return "Canberra Region | FTE - workers within 100km of project address.";
        case SocialCommitmentTypeHour.ACTCanberraInternalLabour:
            return "Canberra Region | Project Team Internal Labour Hours - within 100km of project address.";
        case SocialCommitmentTypeHour.ACTCanberraSubcontractorLabour:
            return "Canberra Region | Subcontractor Labour Hours - within 100km of project address.";
    }
};
export const packageLabourHourCommitmentLineItemSchema = z.object({
    created: z.date(),
    deleted: z.boolean().optional(),
    id: z.string(),
    packageId: z.string().optional(),
    projectId: z.string(),
    projectLabourHourCommitmentId: z.string(),
    targetDescription: z.string().optional(),
    targetName: z.enum(SocialCommitmentTypeHour),
    targetValue: z.number(),
    targetValueRealised: z.number()
});
export const cloneProjectLabourHourCommitmentsForPackage = (packageId, commitments) => {
    return commitments
        .map((c) => {
        return {
            ...c,
            achievedValue: 0,
            id: uuid(),
            packageId,
            projectLabourHourCommitmentId: c.id
        };
    })
        .filter((c) => !projectLevelLabourHourCommitmentType.includes(c.targetName));
};
export const cloneProjectLabourHourCommitmentsFromPackage = (packageId, commitments) => {
    return commitments
        .map((c) => {
        return {
            ...c,
            achievedValue: 0,
            id: uuid(),
            packageId,
            projectLabourHourCommitmentId: c.projectLabourHourCommitmentId
        };
    })
        .filter((c) => !projectLevelLabourHourCommitmentType.includes(c.targetName));
};
export const projectToPackageLabourHourCommitment = (packageId, commitment) => {
    return {
        contractor_package_id: packageId,
        created: commitment.created,
        package_labour_hour_commitment_id: uuid(),
        project_id: commitment.project_id,
        project_labour_hour_commitment_id: commitment.project_labour_hour_commitment_id,
        target_description: commitment.target_description,
        target_type: commitment.target_type,
        target_value: commitment.target_value,
        target_value_realised: commitment.target_value_realised
    };
};
